var _rect, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.078125,
    y: 0.683228,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF1EE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8151_51216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 23,
    width: 16,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0781 23.1793H27.918V30.5533H12.0781V23.1793Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8151_51216)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9991 24.6793C15.7381 24.6793 13.5781 25.4113 13.5781 26.8563C13.5781 28.3143 15.7381 29.0533 19.9991 29.0533C24.2591 29.0533 26.4181 28.3213 26.4181 26.8763C26.4181 25.4183 24.2591 24.6793 19.9991 24.6793ZM19.9991 30.5533C18.0401 30.5533 12.0781 30.5533 12.0781 26.8563C12.0781 23.5603 16.5991 23.1793 19.9991 23.1793C21.9581 23.1793 27.9181 23.1793 27.9181 26.8763C27.9181 30.1723 23.3981 30.5533 19.9991 30.5533Z",
    fill: "#D83612"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8151_51216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 10,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6875 10.6833H25.3075V21.3019H14.6875V10.6833Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8151_51216)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9985 12.111C17.8575 12.111 16.1155 13.852 16.1155 15.993C16.1085 18.127 17.8375 19.867 19.9695 19.875L19.9985 20.589V19.875C22.1385 19.875 23.8795 18.133 23.8795 15.993C23.8795 13.852 22.1385 12.111 19.9985 12.111ZM19.9985 21.302H19.9665C17.0445 21.293 14.6775 18.91 14.6875 15.99C14.6875 13.065 17.0695 10.683 19.9985 10.683C22.9265 10.683 25.3075 13.065 25.3075 15.993C25.3075 18.921 22.9265 21.302 19.9985 21.302Z",
    fill: "#D83612"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallAvatar);
export default __webpack_public_path__ + "static/media/smallAvatar.05e36ba66878cb48071ab11ebbcbc61f.svg";
export { ForwardRef as ReactComponent };